import React, {useEffect, useState} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PriceFormat from "react-number-format"

import MaterialTable from "material-table"
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import Tooltip from "@material-ui/core/Tooltip";

import { projectPricesServices } from "../../../services/projectPricesServices"

import AjaxLoading from "../../AjaxLoading"

import {green, red, grey, blue} from '@material-ui/core/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {faPlusSquare, faSearch} from '@fortawesome/free-solid-svg-icons'
import { faSortUp } from "@fortawesome/free-solid-svg-icons"
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import {_t} from './../../../i18n/lang'
import  { MaterialTableLocaleDelayed } from './../../../i18n/material-table'



const cache = new Map()

const tableIcons = {
    NextPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleRight} { ...props }  /> ),
    PreviousPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleLeft} { ...props } /> ),
    FirstPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleDoubleLeft} { ...props } /> ),
    LastPage: React.forwardRef( (props, ref) => <FontAwesomeIcon icon={faAngleDoubleRight} { ...props } /> ),
    Search: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faSearch} { ...props } /> ),
    SortArrow: React.forwardRef((props, ref) => <FontAwesomeIcon { ...props } icon={faSortUp} /> ),
    ResetSearch: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faTimes} { ...props } size='xs' /> ),
};

const useStyles = makeStyles({
    chipItem: {
        margin: '0 2px',
    }
});

export default function ListDetails(props) {
    const [details, setDetails] = useState([])
    const [projectFeatures, setProjectFeatures] = useState([])
    const [loading, setLoading] = useState(false)
    const { project, addDetail, showAlert, productInCart } = props
    const classes = useStyles()

    useEffect( () => {
        async function fetchData() {
            const projectId = project.id
            if (0  && cache.has(projectId)) {
                let details = cache.get(projectId)
                setDetails(details)
            } else {
                setLoading(true)
                let { details, features } = await projectPricesServices.project(projectId)
                cache.set(projectId, details)
                setDetails(details)
                setProjectFeatures(features)
                setLoading(false)
            }
        }
        fetchData();
    }, [])

    const styleCss = {
        fontSize: '10px'
    }

    const columns = [
        {
            title: _t('PROJECT_DETAILS_TABLE_HEAD_PART'),
            field: 'part',
            cellStyle: {textAlign: 'left'},
            headerStyle: {textAlign: 'left'},
            render(rowData) {
                return  <label style={styleCss}>{rowData.part} {rowData.groupId
                && <Chip variant="outlined" color="primary" size="small"  label={rowData.groupName}/>}
                </label>
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_VEND_NO'),
            field: 'vendorPartNumber',
            render(rowData) {
                return <label style={styleCss}>{rowData.vendorPartNumber}</label>
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_GOODS_NAME'),
            field: 'productName',
            render(rowData) {
                return <label style={styleCss}>{rowData.productName}</label>
            }
        },
        {
            title: _t('PROJECT_DETAILS_TABLE_HEAD_MAX_QTY'),
            field: 'maxQty',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
            render(rowData) {
                return <div>{rowData.maxQty}</div>;
            }
        },
        {
            title: _t('PROJECT_DETAILS_TABLE_HEAD_MAX_QTY_PER_MONTH'),
            field: 'maxQtyPerMonth',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
            render(rowData) {
                return (
                    <>
                        {rowData.maxQtyPerMonth ? (
                            <>
                                {rowData.maxQtyPerMonth}
                            </>
                        ) : (
                            <>
                                <small><i>{_t("PROJECT_DETAILS_MONTH_LIMIT_NOT_SET")}</i></small>
                            </>
                        )}
                        <br/>
                        <Tooltip title= {_t('PROJECT_DETAILS_TOOLTIP_AV_BY_THE_END_OF_MONTH')}>
                            <small style={{margin: '0 2px', color: green[500], cursor: 'help'}}>
                                {_t('PROJECT_DETAILS_AV_BY_THE_END_OF_MONTH')}
                                {rowData.availableByTheEndOfTheMonth ? rowData.availableByTheEndOfTheMonth : 0}
                                {_t('PROJECT_DETAILS_ON_STOCK_PCS')}
                            </small>
                        </Tooltip>
                    </>

                )
            }
        },
        {
            title: _t('PROJECT_DETAILS_TABLE_HEAD_USED_QTY'),
            field: 'usedQty',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
        },
        {
            title: _t('PROJECT_DETAILS_TABLE_HEAD_LEFT_QTY'),
            field: 'leftQty',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
            render(rowData) {
                const { onStock, leftQty } = rowData

                return (
                    <>
                        {leftQty}

                        {onStock !== 0 && (
                            <>
                                <br/>
                                <small style={{margin: '0 2px', color: green[500]}}>
                                    {_t('PROJECT_DETAILS_ON_STOCK')}
                                    {onStock < 0 ?  0 : onStock}
                                    {_t('PROJECT_DETAILS_ON_STOCK_PCS')}
                                </small>
                            </>
                        )}
                    </>
                )
            }
        },
        {
            title: _t('PROJECT_DETAILS_TABLE_HEAD_PRICE'),
            field: 'price',
            type: 'numeric',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
            render(rowData) {
                return (
                    <>
                        <PriceFormat
                            decimalSeparator='.'
                            thousandSeparator={`\u00a0`}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            value={rowData.price}
                            displayType={'text'}
                        />{`\u00a0${rowData.currency}`}
                    </>
                )
            }
        },
    ]

    const projectNumber = project.projectNo
    return (
        <>
            {loading ? (
                <div style={{position: 'relative', minHeight: '10em'}} >
                    <AjaxLoading />
                </div>
            ) : (
                <div style={{padding: '2em 0em 5em 5em'}}>
                    <MaterialTable
                        columns={columns}
                        data={details}
                        title={_t("PROJECT_DETAILS_HEADER") + ` ${projectNumber}`}
                        localization={MaterialTableLocaleDelayed()}
                        options={{
                            showTitle: true,
                            paging: false,
                            actionsColumnIndex: -1,
                            detailPanelColumnAlignment: 'right',
                            pageSizeOptions: [5, 10, 20, 50, 100],
                            headerStyle: {
                                backgroundColor: grey[300]
                            }
                        }}
                        actions={[
                            rowData => {
                                const availableByTheEndOfTheMonth = parseInt(rowData.availableByTheEndOfTheMonth, 10);
                                let tooltip = _t('PRODUCT_ADD_TO_CART')
                                const isDisabled = availableByTheEndOfTheMonth < 1
                                    || rowData.detailsStatus !== 'ACTIVE'
                                    || project.status  !== 'ACTIVE'
                                if (isDisabled) {
                                    tooltip = _t('PRODUCT_NOT_ALLOWED_TO_ADD_TO_CART')
                                }
                                const inCart = productInCart(rowData.projectId, rowData.part)

                                return ({
                                        icon() {
                                            if (isDisabled) {
                                                return <FontAwesomeIcon style={{color: grey[500]}} icon={faPlusSquare} size='xs' />
                                            }

                                            if (inCart) {
                                                return <FontAwesomeIcon style={{color: green[500]}} icon={faPlusSquare} size='xs' />
                                            }

                                            return <FontAwesomeIcon style={{color: blue[500]}} icon={faPlusSquare} size='xs' />
                                        },
                                        onClick: (event, rowData) => {
                                            if (isDisabled) {
                                                return
                                            }

                                            if (inCart) {
                                                const alertMessage =  _t("CANON_ALERT_PRODUCT_ALREADY_CART_1")
                                                    + ` <i>${rowData.productName} (${rowData.part})</i> `
                                                    +  _t("CANON_ALERT_PRODUCT_ALREADY_CART_2")
                                                showAlert("warning", alertMessage, 2000)
                                                return
                                            }

                                            addDetail(rowData, projectFeatures)
                                            const alertMessage =  _t("CANON_ALERT_PRODUCT_ADD_TO_CART_1")
                                                + ` <i>${rowData.productName}</i> `
                                                +  _t("CANON_ALERT_PRODUCT_ADD_TO_CART_2")
                                            showAlert(
                                                "info",
                                                alertMessage,
                                                2000
                                            )
                                        },
                                        tooltip
                                    }
                                )}
                        ]}
                        icons={tableIcons}
                        components={{
                            Toolbar(){
                                return (
                                    <Typography variant="h5" gutterBottom>
                                        {_t("PROJECT_DETAILS_HEADER") + ` ${projectNumber}`}
                                    </Typography>
                                )}
                        }}
                    />
                </div>
            )}
        </>
    )
}
